import React from 'react';
import { Outlet } from 'react-router-dom';

import { AdminProvider } from '../context/AdminContext';

const AdminLayout: React.FC = () => (
  <AdminProvider>
    <Outlet />
  </AdminProvider>
);

export default AdminLayout;
